export const addBeneficiaryNameInPayments = (payments, members) => {
    return payments.map(payment => {

        const updatedDetails = payment.details.map(detail => {
            let beneficiaryName = null

            const member = members.find(member => member.beneficiaryType === detail.beneficiaryType)

            if (member) {
                if (detail.beneficiaryType === 'owner' || detail.beneficiaryType === 'spouse') {
                    beneficiaryName = `${member.firstName} ${member.lastName}`
                } else if (detail.beneficiaryType === 'dependent' && detail.component === '1 CHILD') {
                    beneficiaryName = `${member.firstName} ${member.lastName}`
                }
            }

            return {
                ...detail,
                beneficiaryName
            }
        })

        return {
            ...payment,
            details: updatedDetails
        }

    })
}
